/**
 * Definition of different endpoints of Monitorly API
 * 
 * @author - Harsh Tomar
 */

export enum Endpoints {
  emailLoginSignup = '/auth/passwordless',
  exchangeAccessToken = '/auth/passwordless/exchange',
  users = '/users',
  monitors = '/monitors',
  myProfile = '/my/profile',
  createPing = '/monitors/ping'

}

// export const PATH = {
//   myMonitors:'/my/monitors',
//   monitors: '/monitors/',
//   myProfile: '/my/profile'
// }